var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#AEBCC3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.955 8.166V4.493A3.484 3.484 0 0 1 6.429 1a3.484 3.484 0 0 1 3.475 3.493v3.673h-6.95zM1 15V8.268h10.858V15H1zm6.08-3.366a.652.652 0 1 0-1.302 0 .652.652 0 0 0 1.303 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/password-icon.9d007324.svg";
export { ForwardRef as ReactComponent };